import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Users, Award, ArrowRight } from 'lucide-react';

const Register = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-cyan-50 to-blue-50">
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-4 leading-tight">
              <span style={{ fontFamily: 'Georgia, serif', fontStyle: 'italic', fontWeight: '400' }}>Join</span>{' '}
              <span className="font-black bg-gradient-to-r from-cyan-600 to-blue-600 bg-clip-text text-transparent">us!</span>
            </h1>
            <p className="text-lg md:text-xl lg:text-2xl text-gray-600">Be the change you wish to see in the world.</p>
          </div>

          <div className="grid md:grid-cols-2 gap-12 max-w-5xl mx-auto">
            {/* Lion Card */}
            <Card className="hover:shadow-2xl transition-all duration-300 hover:scale-105">
              <CardHeader className="text-center pb-4">
                <div className="w-20 h-20 bg-gradient-to-r from-cyan-400 to-blue-500 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Award className="w-10 h-10 text-white" />
                </div>
                <CardTitle className="text-2xl md:text-3xl font-bold mb-2">LION</CardTitle>
                <CardDescription className="text-base md:text-lg">Become a Mentor</CardDescription>
              </CardHeader>
              <CardContent className="space-y-4">
                <ul className="space-y-3 text-gray-700">
                  <li className="flex items-start">
                    <span className="mr-2 text-cyan-500">•</span>
                    <span>Are you a professional in your field with the skills and expertise to mold young minds?</span>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-2 text-cyan-500">•</span>
                    <span>Do you have extra hours to volunteer per week?</span>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-2 text-cyan-500">•</span>
                    <span>Would you like to be a part of empowering the youth to be the best they can be?</span>
                  </li>
                </ul>
                <Link to="/register/lion" className="block">
                  <Button className="w-full bg-gradient-to-r from-cyan-500 to-blue-600 hover:from-cyan-600 hover:to-blue-700 text-white text-lg py-6 mt-6">
                    BECOME A LION! <ArrowRight className="ml-2" />
                  </Button>
                </Link>
                <p className="text-xs text-center text-gray-500 italic">*Application subject to approval.</p>
              </CardContent>
            </Card>

            {/* Cub Card */}
            <Card className="hover:shadow-2xl transition-all duration-300 hover:scale-105">
              <CardHeader className="text-center pb-4">
                <div className="w-20 h-20 bg-gradient-to-r from-blue-400 to-purple-500 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Users className="w-10 h-10 text-white" />
                </div>
                <CardTitle className="text-2xl md:text-3xl font-bold mb-2">CUB</CardTitle>
                <CardDescription className="text-base md:text-lg">Become a Mentee</CardDescription>
              </CardHeader>
              <CardContent className="space-y-4">
                <ul className="space-y-3 text-gray-700">
                  <li className="flex items-start">
                    <span className="mr-2 text-blue-500">•</span>
                    <span>Are you a student?</span>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-2 text-blue-500">•</span>
                    <span>Are you an immigrant?</span>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-2 text-blue-500">•</span>
                    <span>Are you in need of mentorship to achieve the next level in your path to success?</span>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-2 text-blue-500">•</span>
                    <span>Are you determined to succeed?</span>
                  </li>
                </ul>
                <Link to="/register/cub" className="block">
                  <Button className="w-full bg-gradient-to-r from-blue-500 to-purple-600 hover:from-blue-600 hover:to-purple-700 text-white text-lg py-6 mt-6">
                    BECOME A CUB <ArrowRight className="ml-2" />
                  </Button>
                </Link>
                <p className="text-xs text-center text-gray-500 italic">*Application subject to approval.</p>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Register;